import videojs from 'video.js';
import * as PlayerEvents from '../../utils/PlayerEvents.js';

const SeekBar = videojs.getComponent('SeekBar');

/**
 * Improve original SeekBar component by seek on drag
 * for vod, aod, live DVR.
 * @ignore
 */
class SeekBarCustomComponent extends SeekBar {
  constructor(player, options) {
    super(player, options);

    this.newTime = undefined;
    this.position = undefined;

    this.initListener();
  }

  initListener() {
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);

    this.player().on(PlayerEvents.SEEKED, () => {
      this.displayTimeToolTip(true);
    });
  }

  update() {
    super.update();
  }

  getCurrentTime_() { // eslint-disable-line
    return (this.player().scrubbing())
      ? this.player().getCache().currentTime
      : this.player().currentTime();
  }

  createEl() {
    const el = super.createEl('div', {
      className: 'vjs-progress-holder',
    }, {
      'aria-label': this.localize('Progress Bar'),
    });

    return el;
  }

  handleMouseDown(event) {
    if (event) {
      event.stopPropagation();
    }

    if (event.type === 'mousedown') {
      event.preventDefault();
    }

    if (event.type === 'touchstart' && !videojs.IS_CHROME) {
      event.preventDefault();
    }

    videojs.dom.blockTextSelection();
    this.addClass('vjs-sliding');
    this.trigger('slideractive');
    this.player().scrubbing(true);

    const doc = this.bar.el().ownerDocument;

    this.on(doc, 'mousemove', this.handleMouseMove);
    this.on(doc, 'mouseup', this.handleMouseUp);
    this.on(doc, 'touchmove', this.handleMouseMove);
    this.on(doc, 'touchend', this.handleMouseUp);

    this.calculateNewTime(event);
    this.player().currentTime(this.newTime);

    this.videoWasPlaying = !this.player().paused();

    if (this.videoWasPlaying) {
      this.player().pause();
    }
  }

  handleMouseMove(event) {
    this.displayTimeToolTip(false);
    this.calculateNewTime(event);
    this.player().getCache().currentTime = this.newTime;
    this.player().currentTime(this.newTime);

    if (!this.player().liveTracker || !this.player().liveTracker.isLive()) {
      this.setPosition();
    }
  }

  handleMouseUp(event) {
    if (event) {
      event.stopPropagation();
    }

    const doc = this.bar.el().ownerDocument;

    videojs.dom.unblockTextSelection();
    this.removeClass('vjs-sliding');
    this.trigger('sliderinactive');

    this.off(doc, 'mousemove', this.handleMouseMove);
    this.off(doc, 'mouseup', this.handleMouseUp);
    this.off(doc, 'touchmove', this.handleMouseMove);
    this.off(doc, 'touchend', this.handleMouseUp);

    if (!this.player().liveTracker || !this.player().liveTracker.isLive()) {
      this.player().currentTime(this.newTime);
      this.setPosition();
    }

    this.player().scrubbing(false);

    if (this.videoWasPlaying) {
      SeekBarCustomComponent.silencePromise(this.player().play());
    }
  }

  static silencePromise(value) {
    value.then(null, () => {});
  }

  setPosition() {
    this.bar.update(this.newTime, super.update());

    const duration = this.player().duration() === Infinity
      ? this.player().liveTracker.liveWindow()
      : this.player().duration();

    this.bar.el().style.width = `${SeekBarCustomComponent.percentage(this.newTime, duration)}%`;
  }

  calculateNewTime(event) {
    const distance = this.calculateDistance(event);
    const { liveTracker } = this.player();

    if (!liveTracker || !liveTracker.isLive()) {
      this.newTime = distance * this.player().duration();

      if (this.newTime === this.player().duration()) {
        this.newTime = this.newTime - 0.1;
      }
    } else {
      const seekableStart = liveTracker.seekableStart();
      const seekableEnd = liveTracker.liveCurrentTime();

      this.newTime = seekableStart + (distance * liveTracker.liveWindow());

      if (this.newTime >= seekableEnd) {
        this.newTime = seekableEnd - 10;
      }

      if (this.newTime <= seekableStart) {
        this.newTime = seekableStart + 0.1;
      }
    }
  }

  static percentage(time, duration) {
    return (time / duration) * 100;
  }

  displayTimeToolTip(show) {
    if (this.bar.timeTooltip !== undefined) {
      if (show) {
        this.bar.timeTooltip.show();
      } else {
        this.bar.timeTooltip.hide();
      }
    }
  }
}

SeekBarCustomComponent.prototype.playerEvent = 'timeupdate';
videojs.registerComponent('SeekBarCustomComponent', SeekBarCustomComponent);
export default SeekBarCustomComponent;
